export const dataTelasReducer = (state, action) => {
  state.items = action.payload.items;
  state.pagination = {
    page: action.meta.arg?.pagina,
    rowsPerPage: action.meta.arg?.itensPorPagina,
    totalPages: action.payload.totalPaginas,
    totalItems: action.payload.totalRegistros,
  };
  state.requestGetParams = action.meta.arg;
};
